export default {
  namespaced: true,
  state: {
    title: "Pacotes Enviados",
    externalModule: "packets",
    itemsKey: "packets",
    hasLink: true,
    checkboxs: true,
    parameters: {
      status: "Enviado"
    }
  },
};
